import React from 'react';
import { BsLinkedin, BsGithub, BsEnvelopeFill } from 'react-icons/bs';
import './btnSocial.css';

const BtnSocial = () => {
  return (
    <>
      <ul className="wrapper">
        <a
          href="https://www.linkedin.com/in/maximilianoghirardi"
          target="_blank"
          rel="noreferrer"
        >
          <li className="icon linkedin">
            <span className="tooltip">LinkedIn</span>
            <span>
              <BsLinkedin />
            </span>
          </li>
        </a>

        <a href="https://github.com/mgmaxi" target="_blank" rel="noreferrer">
          <li className="icon github">
            <span className="tooltip">Github</span>
            <span>
              <BsGithub />
            </span>
          </li>
        </a>
        <a href="mailto:maximiliano.ghirardi@gmail.com">
          <li className="icon email">
            <span className="tooltip">Email</span>
            <span>
              <BsEnvelopeFill />
            </span>
          </li>
        </a>
      </ul>
    </>
  );
};

export default BtnSocial;
